import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSubCategories, loadSubCategories } from '../features/subCategories/subCategorySlice';
import { useGetSubCategoriesQuery } from '../features/subCategories/subCategoriesApiSlice';

const useSubCategory = () => {
  const dispatch = useDispatch();
  const subCategoryFromStore = useSelector(selectSubCategories);
  
  // Only trigger query if store is empty
  const { data: subCategoryFromApi, isLoading, error } = useGetSubCategoriesQuery(undefined, {
    skip: subCategoryFromStore.length > 0
  });

  useEffect(() => {
    // If we got data from API and store is still empty, update store
    if (subCategoryFromApi && subCategoryFromStore.length === 0) {
      dispatch(loadSubCategories(subCategoryFromApi));
    }
  }, [subCategoryFromApi, subCategoryFromStore.length, dispatch]);

  return {
    subCategories: subCategoryFromStore.length > 0 ? subCategoryFromStore : (subCategoryFromApi || []),
    isLoading: subCategoryFromStore.length === 0 && isLoading,
    error
  };
};

export default useSubCategory; 